module.exports = __webpack_public_path__ + "img/banner2.b29be646.jpg";